import { AnyObject } from 'react-final-form';

const hasAnyError = (errors: AnyObject): boolean => {
  if (typeof errors === 'object') {
    Object.keys(errors).some(key => hasAnyError(errors[key]));
  }

  return typeof errors !== 'undefined';
};

export const getConditionNameWithErrors = (errors: AnyObject | undefined) => {
  if (!errors) {
    return;
  }

  const { includes, exceptions } = errors;

  if (Array.isArray(includes)) {
    for (let i = 0; i < includes.length; i += 1) {
      if (hasAnyError(includes[i])) {
        return `includes[${i}]`;
      }
    }
  }

  if (Array.isArray(exceptions)) {
    for (let i = 0; i < exceptions.length; i += 1) {
      if (hasAnyError(exceptions[i])) {
        return `exceptions[${i}]`;
      }
    }
  }
};
